import {NgModule} from "@angular/core";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {ParametreAuthentificationComponent} from "./parametre-authentification.component";
import {GeneralitesComponent} from "@components/admin/parametre/authentification/generalites/generalites.component";
import {GeneralitesHttpService} from "@services/admin/parametre/authentification/generalites-http.service";
import {SamlComponent} from "@components/admin/parametre/authentification/saml/saml.component";
import {FormsModule} from "@angular/forms";
import {CertificatDialogComponent} from "@components/admin/parametre/authentification/saml/certificat-dialog/certificat-dialog.component";
import {ClefPriveeDialogComponent} from "@components/admin/parametre/authentification/saml/clef-privee-dialog/clef-privee-dialog.component";
import {ListeNoireComponent} from "./liste-noire/liste-noire.component";
import {ListeNoireItemComponent} from "./liste-noire/liste-noire-item/liste-noire-item.component";
import {ListeNoireAddComponent} from "./liste-noire/liste-noire-add/liste-noire-add.component";
import {ListeNoireHttpService} from "@services/admin/parametre/authentification/liste-noire-http.service";

export const parametreAuthentificationRoutes : Routes = [
    {
        path: 'Generalites',
        component: GeneralitesComponent,
        canActivate: [AdminGuardProvider]
    }, {
        path: 'SAML',
        component: SamlComponent,
        canActivate: [AdminGuardProvider]
    }, {
        path: 'ListeNoire',
        component: ListeNoireComponent,
        canActivate: [AdminGuardProvider]
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Generalites'
    }, {
        path: '**',
        redirectTo: 'Generalites'
    }
];

@NgModule({
    imports: [
        ShareModule,
        FormsModule,
    ],
    declarations: [
        ParametreAuthentificationComponent,
        GeneralitesComponent,
        SamlComponent,
        CertificatDialogComponent,
        ClefPriveeDialogComponent,
        ListeNoireComponent,
        ListeNoireItemComponent,
        ListeNoireAddComponent,
    ],
    exports: [
        ListeNoireComponent
    ],
    providers: [
        GeneralitesHttpService,
        ListeNoireHttpService,
    ]
})
export class ParametreAuthentificationModule {}
